export const validateAdvancePayment = ({ amount, balance, enableAdvancePayment }) => {
  if (!enableAdvancePayment && balance !== null && Number(amount) > Number(balance)) {
    return `Amount cannot exceed available balance of ${Number(balance).toLocaleString()}`;
  }

  return null;
};

export const addVendorValidationRules = (values) => {
  const errors = {};
  const phoneRegex = /^\+[1-9]\d{0,3}\d{6,11}$/;

  if (!values.name) errors.name = "Vendor name is required";
  else if (values.name.length < 3) errors.name = "Name must be at least 3 characters";
  if (values.primaryPhone && !phoneRegex.test(values.primaryPhone))
    errors.primaryPhone = "Enter valid number (with country code)";
  if (values.oldBalance && values.oldBalance <= 0)
    if (values.oldBalance <= 0) errors.oldBalance = "Old balance must be greater than 0";
  if (values.taxDetails?.gstNumber)
    if (values.taxDetails?.gstNumber.length !== 15)
      errors.taxDetails = { gstNumber: "Invalid GST Number (15 characters required)" };

  return errors;
};

export const purchaseValidationRules = ({ purchaseDetails, purchaseItems, paymentDetails, isPaid, options = {} }) => {
  const errors = {};
  const { balance, enableAdvancePayment } = options;

  if (!purchaseDetails.vendorId) errors.vendorId = "Please select a vendor";
  if (!purchaseDetails.projectId) errors.projectId = "Please select a project";
  if (isPaid && !paymentDetails.fromAccountId) errors.fromAccountId = "Please select an account";
  if (isPaid && !paymentDetails.paidAmount) errors.paidAmount = "Paid amount is required";
  else if (isPaid && paymentDetails.paidAmount <= 0) errors.paidAmount = "Paid amount must be greater than 0";
  else if (isPaid) {
    const amountError = validateAdvancePayment({
      amount: paymentDetails.paidAmount,
      balance,
      enableAdvancePayment,
    });

    if (amountError) errors.paidAmount = amountError;
  }

  if (!purchaseItems.length) errors.purchaseItemId = "Please add some items to the purchase";

  const missingItemIndices = [];
  const missingQtyIndices = [];
  const missingPriceIndices = [];

  purchaseItems.forEach((item, index) => {
    if (!item.purchaseItemId) {
      missingItemIndices.push(index + 1);
    }
    if (!item.quantity || Number(item.quantity) <= 0) {
      missingQtyIndices.push(index + 1);
    }
    if (!item.price || Number(item.price) <= 0) {
      missingPriceIndices.push(index + 1);
    }
  });

  if (missingItemIndices.length > 0 || missingQtyIndices.length > 0 || missingPriceIndices.length > 0) {
    const parts = [];

    if (missingItemIndices.length > 0) {
      const label = "item name";
      const itemLabel = missingItemIndices.length > 1 ? "items" : "item";
      parts.push(`${label} for  ${itemLabel} ${missingItemIndices.join(", ")}`);
    }

    if (missingQtyIndices.length > 0) {
      const label = missingQtyIndices.length > 1 ? "quantities" : "quantity";
      const itemLabel = missingQtyIndices.length > 1 ? "items" : "item";
      parts.push(`${label} for  ${itemLabel} ${missingQtyIndices.join(", ")}`);
    }

    if (missingPriceIndices.length > 0) {
      const label = missingPriceIndices.length > 1 ? "prices" : "price";
      const itemLabel = missingPriceIndices.length > 1 ? "items" : "item";
      parts.push(`${label} for  ${itemLabel} ${missingPriceIndices.join(", ")}`);
    }

    errors.purchaseItems = `Please enter ${parts.join(" and ")}`;
  }

  return errors;
};
